import Repository from "./RepositoryFactoryMain";

const ADD_REVIEW = "add";
const DELETE_REVIEW = "delete";
const UPDATE_REVIEW = "update";
const GET_REVIEW = "get";

export default {
  getReview(payload) {
    return Repository.post(transformRoute(GET_REVIEW), payload);
  },
  addReview(payload) {
    return Repository.post(transformRoute(ADD_REVIEW), payload);
  },
  updateReview(payload) {
    return Repository.post(transformRoute(UPDATE_REVIEW), payload);
  },
  deleteReview(payload) {
    return Repository.post(transformRoute(DELETE_REVIEW), payload);
  },
};

const transformRoute = (route) => {
  return `/Ecom/review/${route}`;
};
